import { createInput } from '@formkit/vue'
import FormKitCurrencyInput from '../../components/forms/FormKitCurrencyInput.vue'

export const formKitCurrencyInput = createInput(FormKitCurrencyInput, {
  type: 'input',
  family: 'text',
  props: ['currencyOptions'],
})
